import "../assets/index-b8f13a1f.css";
import { n as r } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const n = {
  name: "NcLoadingIcon",
  props: {
    /**
     * Specify the size of the loading icon.
     */
    size: {
      type: Number,
      default: 20
    },
    /**
     * The appearance of the loading icon.
     * 'auto' adjusts to the Nextcloud color scheme,
     * 'light' and 'dark' are static.
     */
    appearance: {
      type: String,
      validator(a) {
        return ["auto", "light", "dark"].includes(a);
      },
      default: "auto"
    },
    /**
     * Specify what is loading.
     */
    name: {
      type: String,
      default: ""
    }
  },
  computed: {
    colors() {
      const a = ["#777", "#CCC"];
      return this.appearance === "light" ? a : this.appearance === "dark" ? a.reverse() : ["var(--color-loading-light)", "var(--color-loading-dark)"];
    }
  }
};
var o = function() {
  var e = this, t = e._self._c;
  return t("span", { staticClass: "material-design-icon loading-icon", attrs: { "aria-label": e.name, role: "img" } }, [t("svg", { attrs: { width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { fill: e.colors[0], d: "M12,4V2A10,10 0 1,0 22,12H20A8,8 0 1,1 12,4Z" } }), t("path", { attrs: { fill: e.colors[1], d: "M12,4V2A10,10 0 0,1 22,12H20A8,8 0 0,0 12,4Z" } }, [e.name ? t("title", [e._v(e._s(e.name))]) : e._e()])])]);
}, i = [], s = /* @__PURE__ */ r(
  n,
  o,
  i,
  !1,
  null,
  "626664cd",
  null,
  null
);
const d = s.exports;
export {
  d as default
};
